import React from "react";
import "../styles/header.css";

function Header(){
    return(
        <div className="header">
            <h1>A Simple Calorie Tracker App</h1>
        </div>
    )
}




export default Header;
